<template>
  <div id="compareContractsPage">
    <MainLayout>
      <b-row v-if="contractInformations && contractInformations.length">
        <CompareEditions :contract-informations="contractInformations" />
      </b-row>
    </MainLayout>
  </div>
</template>

<script>
import MainLayout from "@/layouts/MainLayout.vue";
import CompareEditions from "@/components/compare/CompareEditions.vue";

export default {
  components: {
    MainLayout,
    CompareEditions,
  },
  data() {
    return {
      contractInformations: [],
    };
  },
  watch: {
    "$route.query.contract1"() {
      this.fillEditions();
    },
    "$route.query.contract2"() {
      this.fillEditions();
    },
  },
  created() {
    if (this.$route.query.contract1 && this.$route.query.contract2) {
      this.fillEditions();
    }
  },
  methods: {
    fillEditions() {
      if (this.$route.query.contract1 && this.$route.query.contract2) {
        this.contractInformations = [
          this.$route.query.contract1,
          this.$route.query.contract2,
        ];
      } else {
        this.contractInformations = [{}, {}];
      }
    },
  },
};
</script>

<style>
#compareContractsPage .container {
  max-width: 100% !important;
}

#compareContractsPage .navigationContainer.container {
  max-width: 1185px !important;
}
</style>
